/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';
import Logo from '../../static/images/ALFRED_BLACK_SVG.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {useDispatch} from 'react-redux';
import {actionSetLogout} from '../../actions/businessAction';
import { classNames } from '../../core/function/function-generic';

import dashboardInactiveIcon from '../../static/images/nav/dashboard=inactive.png';
import dashboardActiveIcon from '../../static/images/nav/dashboard=active.png';
import settingActiveIcon from '../../static/images/nav/settings=active.png';
import settingInactiveIcon from '../../static/images/nav/settings=inactive.png';
import DeveloperActiveIcon from '../../static/images/nav/developers=active.png';
import DeveloperInactiveIcon from '../../static/images/nav/developers=inactive.png';
import transactinActiveIcon from '../../static/images/nav/transactions=active.png';
import transactinInactiveIcon from '../../static/images/nav/transactions=inactive.png';
import batchActiveIcon from '../../static/images/nav/batch=active.png';
import batchInactiveIcon from '../../static/images/nav/batch=inactive.png';
import teamhActiveIcon from '../../static/images/nav/team=active.png';
import teamInactiveIcon from '../../static/images/nav/team=inactive.png';
import complianceActiveIcon from '../../static/images/nav/compliance=active.png';
import complianceInactiveIcon from '../../static/images/nav/compliance=inactive.png';
import bootOpen from '../../static/images/nav/book-open-01.png';

export const Sidebar = () => {
  const [ isOpenSubNav, setisOpenSubNav ] = useState(false);
  const [ hNav, sethNav ] = useState(0);
  const business = useSelector(state => state.business);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const navigation = [
    { name: 'Dashboard', iconActive: dashboardActiveIcon, iconInactive: dashboardInactiveIcon, route: '/dashboard', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    { name: 'Transactions', iconActive: transactinActiveIcon, iconInactive: transactinInactiveIcon, route: '/withdrawal', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    { name: 'Batch Files', iconActive: batchActiveIcon, iconInactive: batchInactiveIcon, route: '/upload', activeTypeBusiness: ['OUT'], isChild: false },
/*      { name: 'Transaction', icon: PaperAirplaneIcon, idNav:'n-1', isChild: true, children: [
        { name: 'Completed Transactions', icon: DashboardIcon, route: '/completed-transactions', class: '' },
        { name: 'Pending Transactions', icon: DashboardIcon, route: '/pending-transactions',  class: 'm30' }
      ] 
    },  */
    { name: 'Settings', iconActive: settingActiveIcon, iconInactive: settingInactiveIcon, route: '/setting', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    { name: 'Compliance', iconActive: complianceActiveIcon, iconInactive: complianceInactiveIcon, route: '/compliance', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    { name: 'Developers', iconActive: DeveloperActiveIcon, iconInactive: DeveloperInactiveIcon, route: '/developers', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    { name: 'Team', iconActive: teamhActiveIcon, iconInactive: teamInactiveIcon, route: '/roles', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    //{ name: 'Monthly Reports', icon: DocumentPlusIcon, route: '/monthly-reports', activeTypeBusiness: ['OUT', 'IN'], isChild: false },
    /* { name: 'Files by Lot', icon: ClipboardDocumentListIcon, route: '/download' },
    { name: 'Upload Files', icon: DocumentPlusIcon, route: '/upload' }, 
     
    */
    /* { name: 'Integration Docs', iconActive: bootOpen, iconInactive: bootOpen, route: 'link', activeTypeBusiness: ['OUT', 'IN'] }, */
  ];
  
  const handleNavigate = (root)=>{

    navigate(root);
  }

  const handleLogout = ()=>{
    dispatch(actionSetLogout());
    navigate('/');
  }

  const isActiveicon = (icon, isActive) => {
    const imgNav = `./../../static/images/nav/${isActive ? icon+'=active.png' : icon+'=inactive.png'}`;
    console.log(imgNav)
    return imgNav;
  }

  window.addEventListener('resize', function(){
    const h = document.getElementById('menu')?.clientHeight;
    sethNav(h)
  });

  return (
    <div id={'menu'} className={`flex min-h-0 flex-1 flex-col bg-white nav-bord h-[${hNav+'px'}] nav-content`}>
      <div className="flex flex-col pt-5 pb-4">
        <div className="flex flex-shrink-0 flex-col items-center px-4">
          <img
            className="h-8 w-auto logo-Nav"
            src={Logo}
            alt="Alfredpay Logo"
          />
{/*           <div className='btn-sanddbox'>
            <a>Sandbox</a>
          </div> */}
        </div>
        <nav className="mt-[36px] bg-white" aria-label="Sidebar">
          {navigation.map((item, index) => {
            if (!item.children) {
              if (item.activeTypeBusiness.includes(business.typeBusiness)) {
                return (
                  <a
                    id={item.idNav ? item.idNav : ''}
                    key={item.name}
                    onClick={() => handleNavigate(item.route)}
                    href={item.href}
                    className={classNames(
                      location.pathname === item.route
                        ? 'text-gray-900 link-active'
                        : 'text-gray-600 hover:text-gray-900 color-a m30 link-border',
                      'flex items-center px-2 py-2 text-[14px] font-medium cursor-pointer m30'
                    )}
                  >
                    <img
                    className='mr-3 flex-shrink-0 h-6 w-6 ml32 ml-mq-0'
                    src={location.pathname === item.route ? item.iconActive : item.iconInactive} 
                    alt="" />
                    <span className="flex-1 link-action-mq">{item.name}</span>
                  </a>
                );
              } else {
                return null;
              }
            } else {
              return (
                <div key={item.name + index + 1}>
                  <div
                    onClick={() => setisOpenSubNav(!isOpenSubNav)}
                    className={`
                      text-gray-600 hover:text-gray-900 color-a m30 link-border
                      flex items-center px-2 py-2 text-sm font-medium cursor-pointer m30
                    `}
                  >
                    {item.name}
                  </div>
                  {item.children?.map((subItem, index) => (
                    <div
                      key={index + 1}
                      className={isOpenSubNav ? 'text-center subNavOpen' : 'text-center subNavClose'}
                    >
                      <a
                        key={subItem.name + index}
                        onClick={() => handleNavigate(subItem.route)}
                        href={subItem.href}
                        className={`flex items-center px-2 py-2 text-sm font-medium cursor-pointer ${subItem.class}`}
                      >
                        <span className="flex-1">{subItem.name}</span>
                      </a>
                    </div>
                  ))}
                </div>
              );
            }
          })}
          <div className='mr-4 ml-4'>
            <div className='flex b-top mt-[30px]'>
              <a
                target='_blank'
                href='http://alfred.gitbook.io/'
                className={'flex m30 link-border first-letter:flex items-center cursor-pointer m30 mt-[30px]'
                }
              >
                <img
                  className='mr-3 flex-shrink-0 h-6 w-6 '
                  src={bootOpen} 
                  alt="" />
                <span className="flex-1 link-action-mq text-14-lh20 ">Integration Docs</span>
              </a>
            </div>
          </div>
        </nav>
      </div>
      <div className="p-4 h-logout">
        <a className="color-Logout" onClick={handleLogout}>
          <div className="flex w-full justify-center items-center cursor-pointer">
            <ArrowLeftOnRectangleIcon className="mr-2 w-[1.5rem] color-Logout" />
            Logout
          </div>
        </a>
      </div>
    </div>
  );
}